import _reduce from 'lodash/reduce';
import _isEmpty from 'lodash/isEmpty';
import { defaultMemoize } from 'reselect';
import filterTypeReader from '../../readers/FilterType';
export var getSelectedFilterCount = function getSelectedFilterCount(selectedFilters) {
  var count = _reduce(selectedFilters, function (totalCount, filter) {
    return _isEmpty(filter.values) || !filter.operator ? totalCount : totalCount + 1;
  }, 0);
  return count;
};
export var getVisibleFilterTypesForDialog = defaultMemoize(function (filterTypes) {
  return filterTypes === null || filterTypes === void 0 ? void 0 : filterTypes.filter(function (type) {
    return !filterTypeReader.hideInFilterDialog(type);
  });
});